import React from "react";
import { createRoot } from "react-dom/client";
import { StylesProvider, createGenerateClassName } from "@mui/styles";
import "fast-text-encoding";
//Limitless Imports
import { PlatformResourceContextProvider } from "@limitless/common/hooks/platform-resource/PlatformResourceContext";
import { initLogger } from "@limitless/common/utils/Logging";
import { getDefaultHIWSlides } from "@limitless/customer/utils";
import { ClientContext, log } from "@limitless/common/utils";
import CustomerLifecycleProvider from "@limitless/customer/providers/CustomerLifecycleProvider";
import { TranslationProvider } from "@limitless/common/hooks/translation/TranslationContext";
import "./index.css";
import LiveMessenger from "./LiveMessenger";
import LLMContextProvider from "./hooks/LLMContextProvider";
import { createEncryptor } from "./utils/encryption/LocalStorageEncryption";
import { getLLMResources } from "./utils/LLMResourceHelper";

// Root div id where the app should be rendered
const ROOT_ELEMENT = "limitless-root";

// Create a unique prefix for the production build inline CSS classes
const generateClassName = createGenerateClassName({
    productionPrefix: "llm",
    seed: "limitless"
});

//Validate the Client input to ensure we have a valid Client Context
if (!ClientContext.validateConfig(ROOT_ELEMENT)) {
    log.error("Live Messenger Configuration is invalid, please check all properties");
} else {
    // we keep the secret super simple because the uglifier will turn everything to garbage anyway
    const secretKey = "a1";

    initLogger();
    // Setup Environment Logging Level, default to info
    log.setLevel(process.env.REACT_APP_LOG_LEVEL || "info");

    const storageKey = `persist:llm-${ClientContext._tenantName}`;

    let storageConfig = null;

    if (ClientContext._persistenceEnabled) {
        storageConfig = createEncryptor({
            secretKey,
            storageKey
        });
    } else {
        //just in case a client flips from on/off
        localStorage.removeItem(storageKey);
    }

    const llmResourceList = getLLMResources(ClientContext._hiwSet);

    const container = document.getElementById(ROOT_ELEMENT);
    const root = createRoot(container);

    root.render(
        <StylesProvider generateClassName={generateClassName}>
            <TranslationProvider>
                <CustomerLifecycleProvider storageConfig={storageConfig} delayNonEssentialCalls>
                    <PlatformResourceContextProvider
                        resourceList={llmResourceList}
                        applicationName="live_messenger"
                        defaultContentMap={{
                            hiwSlides: getDefaultHIWSlides()
                        }}
                    >
                        <LLMContextProvider>
                            <LiveMessenger />
                        </LLMContextProvider>
                    </PlatformResourceContextProvider>
                </CustomerLifecycleProvider>
            </TranslationProvider>
        </StylesProvider>
    );
}
